import { useDependency } from 'ditox-react';
import { useSubscription } from 'observable-hooks';
import { useNavigate } from 'react-router';
import { WEB_SOCKET_MANAGER_TOKEN } from '@/container';
import ROUTES from '@/routes';
import { getUserId } from '@/stores/auth';
import { addTranslateToast } from '@/stores/toast';

export default function useGroupSocketEvents(groupId?: number) {
  const navigate = useNavigate();
  const webSocketManager = useDependency(WEB_SOCKET_MANAGER_TOKEN);

  useSubscription(webSocketManager.event$, ({ action, params }) => {
    switch (action) {
      case 'disbandGroup':
      case 'leaveGroup': {
        const userId = getUserId();
        if (params.groupId !== groupId) break;
        if (action === 'leaveGroup' && params.userId !== userId) break;

        navigate(ROUTES.MESSAGES.$path(), { replace: true });
        addTranslateToast({
          type: 'error',
          message: 'conversation.group.has-left',
        });
        break;
      }
    }
  });
}
